import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID as string,
    authority: 'https://login.microsoftonline.com/japeto.ai',
    redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
